import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit'
import { GET } from 'rest/request'
import * as urls from 'rest/urls'
import { RootState } from 'store'

const initialState: app.initialState = {
  theme: {
    light: true,
    mode: 'auto',
  },
}

export const getConfig = createAsyncThunk<app.ConfigResponse>('app/getConfig', async () => {
  return await GET(urls.config)
})

const applyTheme = (light: boolean) => {
  document.documentElement.className = `--${light ? 'light' : 'dark'}Theme`
}

export const appSlice = createSlice({
  name: 'app',
  initialState,
  reducers: {
    updateTheme: (state, action: PayloadAction<app.ThemeType | { mode: app.ThemeMode, lightTheme: boolean }>) => {
      if (typeof action.payload === 'string') {
        const lightTheme = action.payload === 'light'
        applyTheme(lightTheme)
        state.theme.light = lightTheme
        state.theme.mode = action.payload
      } else {
        applyTheme(action.payload.lightTheme)
        state.theme.mode = action.payload.mode
        state.theme.light = action.payload.lightTheme
      }
    },
  },
  extraReducers(builder) {
    builder.addCase(getConfig.fulfilled, (state, action) => {
      state.config = action.payload.config
      state.contact = action.payload.contact
    })
  },
})

export const { updateTheme } = appSlice.actions

export const selectTheme = (state: RootState) => state.app.theme
export const selectConfig = (state: RootState) => state.app.config
export const selectConfigContact = (state: RootState) => state.app.contact
export const selectLightTheme = (state: RootState) => state.app.theme.light

export default appSlice.reducer
